
import donneesJeuxConcours from '../../data/donneesJeuxConcours'
function prochainObjectif(id) {
    const jeu = donneesJeuxConcours.find(x => x.id === id);
    if (jeu != null) {
        if (jeu.qualifFaute !== undefined) return jeu.qualifFaute === 0 ? 'Tu dois réaliser 0 faute.' : 'Tu dois faire moins de ' + (jeu.qualifFaute + 1) + ' fautes.'
        if (jeu.qualifTemps !== undefined) return 'Tu dois réussir le test en moins de ' + jeu.qualifTemps + ' secondes.';
        if (jeu.qualifScore !== undefined) return 'Tu dois réussir le test avec un score supérieur ou égal à ' + jeu.qualifScore + '.';
    }
    return "Réussir le test";
}

function messageErreur(id) {
    const jeu = donneesJeuxConcours.find(x => x.id === id);
    if (jeu != null) {
        if (jeu.qualifFaute !== undefined) return jeu.qualifFaute === 0 ? 'Tu devais réaliser un sans-faute pour te qualifier.' : "Tu n'as pas réussi à faire moins de " + (jeu.qualifFaute + 1) + ' fautes pour te qualifier.'
        if (jeu.qualifTemps !== undefined) return 'Tu devais réussir le test en moins de ' + jeu.qualifTemps + ' secondes pour te qualifier.';
        if (jeu.qualifScore !== undefined) return 'Tu devais obtenir un score supérieur ou égal à ' + jeu.qualifScore + ' pour te qualifier.';

    }
    return '';
}

function modifierType(type)
{
    switch (type) {
        case 'orthographemot':
            return 'Mot';
        case 'phraseerreur':
            return 'Relecture';
        case 'phrasetrou':
            return 'Trous';
        case 'verbeconjugaison':
            return 'Conjugaison';
        case 'dictee':
            return 'Dictée';
        case 'qcm':
            return 'Quiz';
        case 'memoire':
            return 'Mémoire';
        case 'listemots':
            return 'Pyramide';
        case 'motdefinition':
            return 'Définition';
        case 'mastermind-mot':
            return 'Motus';
        case 'desordre':
            return 'Désordre';
            case 'qcmmelange':
                return 'Mélange';
                case 'textetrou':
                    return 'Compléter';
       default:
        return '';




    }
}

function creerEtape(liste) {
    let tabItem = [];
    let i;
    for (i = 0; i < liste.length; i++) {

        tabItem.push({ description: modifierType(liste[i].type) })
    }
    tabItem.push({ description: "Fin" })



    return tabItem;
}

export { prochainObjectif, messageErreur, creerEtape }